<!-- src/app/timeline-notes/timeline-notes.component.html -->
<div class="timeline-container">
    <div class="timeline-wrapper">
      <div class="timeline">
        <div class="timeline-row" *ngFor="let note of timelineNotes; let i = index">
          <div class="timeline-item">
            <div class="timeline-date">
              {{ note.createdAt | date:'MMM dd, yyyy' }}
            </div>
            <div class="note-card">
              <div class="note-indicator" [ngClass]="note.color"></div>
              <div class="note-content">
                <h4 class="note-title">{{ note.title }}</h4>
                <p class="note-description">{{ note.description }}</p>
                <div class="note-footer">
                  <span class="added-by">Added by {{ note.addedBy }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- If no notes are available -->
        <div class="no-notes" *ngIf="timelineNotes.length === 0">
          <p>No timeline notes available. Click "Add New Note" to create your first note.</p>
        </div>
      </div>
    </div>
  </div>